import { cn } from "../../utils/classnames.js";
import { getTargetBlankA11yHint } from "../../utils/i18n.js";
import { buttonVariants } from "./button-variants.js";
import { useLayoutContext } from "../../hooks/layout-context.js";
import "class-variance-authority";
import { createElement } from "react";
import { useLingui } from "@lingui/react";
import { getDestinationTypeAwareLinkProps, isHttpHref } from "@bitcart/core/navigation";
//#region src/components/atoms/link-button.tsx
const LinkButton = ({ disabled = false, expandOnHover = false, isOriginAware = true, size, variant, className, href, children, ...props }) => {
	const { Link } = useLayoutContext();
	const { i18n } = useLingui();
	const linkProps = {
		...getDestinationTypeAwareLinkProps({
			href,
			isOriginAware
		}),
		...props
	};
	const a11yAwareLinkProps = isHttpHref(href) ? {
		href,
		a11yHint: getTargetBlankA11yHint(i18n)
	} : { href };
	const disabledProps = disabled ? {
		"aria-disabled": true,
		tabIndex: -1
	} : {};
	return createElement(Link, {
		className: cn(buttonVariants({
			variant,
			size
		}), {
			"sm:hover:scale-105 hover:scale-102": expandOnHover && !disabled,
			"pointer-events-none cursor-not-allowed opacity-50": disabled
		}, className),
		...linkProps,
		...a11yAwareLinkProps,
		...disabledProps
	}, children);
};
//#endregion
export { LinkButton };

//# sourceMappingURL=link-button.js.map